module.exports = __webpack_public_path__ + "static/img/组 2886.7319d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2886.png
// module id = ZFev
// module chunks = 0